import { CameraGroupIcon } from '@hakimo-ui/hakimo/ui-elements';

interface Props {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

function CameraGroupHeader({ title, subtitle, actions }: Props) {
  return (
    <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 sticky top-0 z-10 flex items-center justify-between py-2">
      <div className="ml-6 flex items-center gap-3">
        <CameraGroupIcon className="dark:text-dark-text text-onlight-text-1 h-5 w-5" />
        <div className="flex flex-col">
          <h1 className="dark:text-dark-text text-onlight-text-1 text-sm font-medium">
            {title}
          </h1>
          {subtitle && (
            <h2 className="text-ondark-text-3 dark:text-ondark-text-1 text-xs">
              {subtitle}
            </h2>
          )}
        </div>
      </div>

      <div className="mr-6 flex gap-2">{actions}</div>
    </div>
  );
}

export default CameraGroupHeader;
